import { render, staticRenderFns } from "./RemoveCreditCardModal.vue?vue&type=template&id=70ffb2e9&scoped=true&"
import script from "./RemoveCreditCardModal.vue?vue&type=script&lang=ts&"
export * from "./RemoveCreditCardModal.vue?vue&type=script&lang=ts&"
import style0 from "./RemoveCreditCardModal.vue?vue&type=style&index=0&id=70ffb2e9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ffb2e9",
  null
  
)

export default component.exports